import Store from './storeStyle';
import Uplay from './uplayStyle';

interface IThemes {
  [key: string]: string;
  Store: string,
  Uplay: string
}

const Themes = {
  Store,
  Uplay
};

export interface ITheme {
  font: string;
  boldFont: string;
  fontWeight: string;
}

export default Themes;
